/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "../../shared/Globals";
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { TabsNav, TabsNavItem } from "../TabsNav";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";

class ResultsReview extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        }
    }

    async componentDidMount() {
        await this.getSettings();
        this.load();
    }

    groupList = (list) => {
        let grouped = {};
        list.forEach(row => {
            if (!grouped[row.specimen.sid])
                grouped[row.specimen.sid] = { sid: row.specimen.sid, specimen: row.specimen, rows: [] };
            grouped[row.specimen.sid].rows.push(row);
        });

        

        let result = [];
        for(let k in grouped) {
            if(!grouped[k].panels)
                grouped[k].panels = [];

            grouped[k].rows.forEach(row => {
                let panel = grouped[k].panels.find(a => a.id === row.panel.id);

                if(panel)
                    panel.tests.push(row);
                else
                    grouped[k].panels.push({id: row.panel.id, code: row.panel.code, name: row.panel.name, tests: [row]});
            });
            result.push(grouped[k]);
        }

        return result;
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/result/review/list');
            if(j.list)
                this.setState({list: this.groupList(j.list)});
            else if(j.errorCode)
                this.alert(j.errorMesage);
        }
        catch(e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    toggle = (row) => {
        row.show = !row.show;
        this.setState({list: this.state.list});
    }

    editResult = (target) => {
        target.editResult = true;
        this.setState({list: this.state.list});
    }

    changeResult = (e, target) => {
        target.result.stringResult = e.target.value;
        this.setState({list: this.state.list});
    }

    saveResult = async (target, row) => {
        try {
            let numericResult = 0;
            try {
                numericResult = parseFloat(target.result.stringResult);
                if(isNaN(numericResult))
                    numericResult = 0;
            }
            catch {}
            let j = await qreq.postAsync('/api/result/save', {specimenID: row.specimen.id, targetID: target.id, stringResult: target.result.stringResult, numericResult: numericResult, referenceRange: target.refRange, units: target.units });
            if(j.errorCode === 0) {
                target.editResult = false;
                this.setState({list: this.state.list});
            }
            else
                this.alert(j.errorMessage);
        }
        catch(e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    render() {
        return <div className="container-fluid">
            <TabsNav>
                <TabsNavItem title="All" to={'/results/review'} />
            </TabsNav>
            <h1>Results Review</h1>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{width: '50px'}}></th>
                        <th><span className="d-none d-md-inline">{this.T('specimen')}</span> ID</th>
                        <th>Patient</th>
                        <th className="d-none d-md-table-cell">Account</th>
                        <th className="d-none d-md-table-cell">Collected</th>
                        <th className="d-none d-md-table-cell">Received</th>
                    </tr>
                </thead>
                    {this.state.list?.map((row, idx) => <tbody key={idx}>
                    <tr>
                        <td><span role="button" title={row.show ? 'Collapse' : 'Expand'} onClick={() => this.toggle(row)}><Icon icon={row.show ? 'faCaretDown' : 'faCaretRight'} /></span></td>
                        <td>{row.specimen.sid}</td>
                        <td>{row.specimen.order.patient.firstName} {row.specimen.order.patient.lastName} <span className="text-muted">({row.specimen.order.patient.birthDate})</span></td>
                        <td className="d-none d-md-table-cell">{row.specimen.order.accountName}</td>
                        <td className="d-none d-md-table-cell">{Globals.toMDYHMLocalDateStringOrDiff(row.specimen.collectedDate)}</td>
                        <td className="d-none d-md-table-cell">{Globals.toMDYHMLocalDateStringOrDiff(row.specimen.receivedDate)}</td>
                    </tr>
                    {row.show && <tr>
                        <td colSpan={6}>
                            {row.panels.map((panel, idx) => <div key={'panel-' + idx}>
                                <div><strong>{panel.name}</strong></div>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th width="25%">Test</th>
                                            <th width="25%">Result</th>
                                            <th width="25%">Ref Range</th>
                                            <th width="25%">Units</th>
                                        </tr>
                                    </thead>
                                <tbody>
                                    {panel.tests.map((r, idx) => <tr key={'target-' + idx}>
                                        <td>{r.name}</td>
                                        <td>
                                            {r.editResult ? <div className="input-group">
                                                <input type="text" className="form-control" autoFocus value={r.result.stringResult} onChange={e => this.changeResult(e, r)} />
                                                <span className="input-group-text" role="button" onClick={() => this.saveResult(r, row)}><Icon icon="faSave" /></span>
                                            </div>
                                                : <div role="button" onClick={() => this.editResult(r)}>{r.result.stringResult ? r.result.stringResult : <i>None</i>}</div>}

                                        </td>
                                        <td>{r.refRange}</td>
                                        <td>{r.units}</td>
                                    </tr>)}
                                </tbody>
                            </table>
                            </div>)}
                        </td>
                    </tr>}
                    </tbody>)}
            </table>
        </div>
    }
}

export default withParamsAndNavigate(ResultsReview);